// extracted by mini-css-extract-plugin
export var root = "CircleImage-module--root--tEiUS";